var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActionImpactNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 13C10.25 13.4142 10.5858 13.75 11 13.75H19C19.0721 13.75 19.129 13.7792 19.1629 13.8143C19.1933 13.8457 19.2033 13.8775 19.1991 13.9148C19.0532 15.2229 18.5958 16.4817 17.8596 17.5835C16.9531 18.9402 15.6646 19.9976 14.1571 20.622C12.6496 21.2464 10.9908 21.4098 9.3905 21.0915C7.79016 20.7732 6.32015 19.9874 5.16637 18.8336C4.01259 17.6798 3.22685 16.2098 2.90852 14.6095C2.59019 13.0092 2.75357 11.3504 3.37799 9.84286C4.00242 8.33537 5.05984 7.0469 6.41655 6.14038C7.51826 5.40424 8.77715 4.94681 10.0852 4.80087C10.1225 4.79671 10.1543 4.80669 10.1857 4.83707C10.2208 4.87096 10.25 4.92792 10.25 5V13Z",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9148 2.80087C14.6841 2.88671 15.4391 3.08058 16.1571 3.37799C17.1581 3.79259 18.0675 4.40029 18.8336 5.16637C19.5997 5.93245 20.2074 6.84193 20.622 7.84286C20.9194 8.56087 21.1133 9.31586 21.1991 10.0852C21.2033 10.1225 21.1933 10.1543 21.1629 10.1857C21.129 10.2208 21.0721 10.25 21 10.25L14 10.25C13.8619 10.25 13.75 10.1381 13.75 10L13.75 3C13.75 2.92792 13.7792 2.87096 13.8143 2.83707C13.8457 2.80669 13.8775 2.79671 13.9148 2.80087Z",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    className: "path-fill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionImpactNew);
export default __webpack_public_path__ + "static/media/ActionImpactNew.baea4c26.svg";
export { ForwardRef as ReactComponent };